export default "<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n  <app-loader></app-loader>\n</ion-app>\n"